import { getHistoryUrlParams } from '@/store/gamestate/gamestate'
import { getSetupParams } from '@/helpers/practice_trainer_calls'

const trainerCalls = {
  api_practice_session(
    { dispatch, rootGetters },
    { settings, gameformat, repeatHand, playFromHere, settingsHand, namespace },
  ) {
    const selectedDrill = rootGetters.drills_selected_drill
    const name = selectedDrill?.id ? selectedDrill.name : ''

    const solElite = rootGetters ? rootGetters[`${namespace}/sol_elite`] : null
    const custree_id = solElite?.want_use && solElite.cTree ? solElite.cTree.id : null

    const gmfQuery = custree_id
      ? {
          format: custree_id ? 'Custom' : gameformat.gametype_format, // TODO remove this after be fix
        }
      : {
          format: gameformat.gametype_format,
        }

    const data = {
      name,
      settings,
      ...gmfQuery,
      ...(selectedDrill?.id ? { drill: selectedDrill?.id } : {}),
    }
    dispatch('api_call', {
      method: 'POST',
      mutation: 'api_practice_session',
      action: 'hands_set_session',
      actionArgs: { repeatHand, playFromHere, settingsHand },
      endpoint: 'poker/practice/sessions/',
      data,
      messages: [{ type: 'success' }, { type: 'error' }],
    })
  },
  api_practice_setup(
    { dispatch, rootGetters },
    { namespace, last_hand_query, keepBoard, shouldRegisterCheats },
  ) {
    // console.log(rootGetters.api_get_data('api_poker_available_shortcuts', 'tra/alpha'), 'tra/alpha')
    // console.log(rootGetters.api_get_data('api_poker_available_shortcuts', namespace), namespace)

    let params = getSetupParams({
      namespace,
      rootGetters,
      last_hand_query,
      availableShortcuts: rootGetters.api_get_data('api_poker_available_shortcuts', 'tra/alpha'),
    })
    const gameformat = rootGetters[`${namespace}/gameformat`]

    params = {
      ...params,
      ...(keepBoard ? { board: last_hand_query.board_tmp } : {}),
      ...(shouldRegisterCheats ? { is_competitive: false } : {}),
    }

    const callParams = {
      namespace,
      params,
      last_hand_query,
    }

    const endpoint = 'poker/practice/practice-hands/'
    const gwCacheId = `${namespace}_${endpoint}_${JSON.stringify(params)}`

    dispatch('api_call', {
      method: 'POST',
      endpoint,
      gwCacheId,
      gwCacheInvalidate: true,
      action: `${namespace}/gamestate_set_practice_setup`,
      mutation: 'api_practice_setup',
      data: params,
      actionArgs: { namespace, callParams },
      mutationArgs: { namespace },
      hasCancel: false,
      fn: gameformat?.is_subscribed
        ? result => {
            if (!result.error) {
              dispatch('api_call', {
                method: 'POST',
                endpoint,
                gwCacheId,
                gwCacheAdd: true,
                gwCacheSkipOnError: true,
                params: { next: true },
                data: params,
                hasCancel: false,
              })
            }
          }
        : null,
    })
  },
  api_practice_setup_repeat(
    { dispatch, rootGetters },
    { namespace, repeatParams, playFromHere, last_hand_query, shouldRegisterCheats },
  ) {
    const callParams = {
      params: repeatParams,
      last_hand_query,
    }
    repeatParams = {
      ...repeatParams,
      session: rootGetters.session_uid,
      ...(shouldRegisterCheats ? { is_competitive: false } : {}),
    }

    const endpoint = 'poker/practice/practice-hands/'
    const gwCacheId = `${namespace}_${endpoint}_${JSON.stringify(repeatParams)}`

    dispatch('api_call', {
      method: 'POST',
      endpoint,
      gwCacheId,
      gwCacheInvalidate: true,
      action: `${namespace}/gamestate_set_practice_setup`,
      mutation: 'api_practice_setup',
      data: repeatParams,
      actionArgs: { namespace, callParams, playFromHere },
      mutationArgs: { namespace },
      hasCancel: false,
      // fn: hasCacheNext ?
      //   (result) => {
      //     if (!result.error) {
      //       dispatch('api_call', {
      //         method: 'POST',
      //         endpoint,
      //         gwCacheId,
      //         gwCacheAdd: true,
      //         gwCacheSkipOnError: true,
      //         params: { next: true },
      //         data: repeatParams,
      //         hasCancel: false,
      //       })
      //     }
      //   }
      //   : null,
    })
  },

  api_practice({ dispatch, rootGetters }, { namespace }) {
    const trainer_practice_hand_id = rootGetters[`${namespace}/trainer_practice_hand_id`]
    const history_spot = rootGetters[`${namespace}/history_spot`]
    let history_spots = rootGetters[`${namespace}/history_spots`]
    const last_spot_street = rootGetters[`${namespace}/last_spot_street`]
    const street = rootGetters[`${namespace}/street`]
    const gameformat = rootGetters[`${namespace}/gameformat`]
    const query_hand_tmp = rootGetters[`${namespace}/query_hand_tmp`]
    const trainer_specific_spot = rootGetters[`${namespace}/trainer_specific_spot`]
    const query_fullhand_setup = rootGetters[`${namespace}/query_fullhand_setup`]

    const solElite = rootGetters ? rootGetters[`${namespace}/sol_elite`] : null
    const custree_id = solElite?.want_use && solElite.cTree ? solElite.cTree.id : null

    let board = ''

    if (trainer_specific_spot) {
      history_spots = history_spots.filter(e => e.id < history_spot?.id)
      board = rootGetters[`${namespace}/street_board_tmp`](street)
        .filter(c => !c.includes('E'))
        .join('')
    } else {
      board = rootGetters[`${namespace}/street_board_tmp`](last_spot_street)
        .filter(c => !c.includes('E'))
        .join('')
    }

    const hp = getHistoryUrlParams({ history_spots })
    const hand = query_hand_tmp
    const rng = query_fullhand_setup.fh_rng || 'off'
    // const opponent_positions = query_fullhand_setup.fh_opponent.split(',').filter(i => i)
    const opponent_positions = query_fullhand_setup.fh_opponent_tmp.split(',').filter(i => i)
    const trainerMode = query_fullhand_setup.fh_trainer_mode
    const duration =
      trainerMode === 'stop_end_of_hand'
        ? 'full_hand'
        : trainerMode === 'stop_end_of_street'
          ? 'street'
          : 'spot' // Performance thing for BE

    const data = {
      ...(custree_id
        ? { custom_tree_id: custree_id }
        : {
            gametype: gameformat.gametype,
            depth: gameformat.depth,
            stacks: gameformat.stacks,
          }),
      preflop_actions: hp.preflop_actions,
      flop_actions: hp.flop_actions,
      turn_actions: hp.turn_actions,
      river_actions: hp.river_actions,
      board,
      hand,
      rng,
      opponent_positions,
      practice_hand_id: trainer_practice_hand_id,
      duration,
    }
    const res = dispatch('api_call', {
      method: 'POST',
      mutation: 'api_practice',
      endpoint: `poker/practice/hero-situation/`,
      action: `${namespace}/gamestate_set_api_practice`,
      actionArgs: { namespace, trainer_practice_hand_id },
      mutationArgs: { namespace },
      data,
      hasCancel: false,
    })
    return res
  },
  api_practice_bot_action({ dispatch, rootGetters }, { namespace, callTimeConf }) {
    const trainer_practice_hand_id = rootGetters[`${namespace}/trainer_practice_hand_id`]
    const history_spots = rootGetters[`${namespace}/history_spots`]
    const last_spot_street = rootGetters[`${namespace}/last_spot_street`]
    const gameformat = rootGetters[`${namespace}/gameformat`]
    const query_hand_tmp = rootGetters[`${namespace}/query_hand_tmp`]
    const query_fullhand_setup = rootGetters[`${namespace}/query_fullhand_setup`]

    const solElite = rootGetters ? rootGetters[`${namespace}/sol_elite`] : null
    const custree_id = solElite?.want_use && solElite.cTree ? solElite.cTree.id : null

    const hp = getHistoryUrlParams({ history_spots })
    const board = rootGetters[`${namespace}/street_board_tmp`](last_spot_street)
      .filter(c => !c.includes('E'))
      .join('')

    const hero_position = query_fullhand_setup.fh_hero_tmp
    const opponent_positions = query_fullhand_setup.fh_opponent_tmp.split(',').filter(i => i)

    if (!hero_position) {
      // I dont really know what to look for ... so lets start with this
      console.error(`ERROR - empty hero_position`)
    }

    const data = {
      ...(custree_id
        ? { custom_tree_id: custree_id }
        : {
            gametype: gameformat.gametype,
            depth: gameformat.depth,
            stacks: gameformat.stacks,
          }),
      preflop_actions: hp.preflop_actions,
      flop_actions: hp.flop_actions,
      turn_actions: hp.turn_actions,
      river_actions: hp.river_actions,
      board,
      hand: query_hand_tmp,
      hero_position,
      opponent_positions,
      practice_hand_id: trainer_practice_hand_id,
    }
    dispatch('api_call', {
      method: 'POST',
      mutation: 'api_practice_bot_action',
      endpoint: `poker/practice/bot-action/`,
      action: `${namespace}/gamestate_set_api_practice_bot_action`,
      actionArgs: { namespace, callTimeConf, trainer_practice_hand_id },
      mutationArgs: { namespace },
      data,
      hasCancel: false,
    })
  },
  api_practice_silent({ dispatch, rootGetters }, { namespace, actionWithoutPracticeId }) {
    const trainer_practice_hand_id = rootGetters[`${namespace}/trainer_practice_hand_id`]

    const history_spot = rootGetters[`${namespace}/history_spot`]
    let history_spots = rootGetters[`${namespace}/history_spots`]
    const street = rootGetters[`${namespace}/street`]
    const gameformat = rootGetters[`${namespace}/gameformat`]
    const query_hand_tmp = rootGetters[`${namespace}/query_hand_tmp`]
    const query_fullhand_setup = rootGetters[`${namespace}/query_fullhand_setup`]

    const solElite = rootGetters ? rootGetters[`${namespace}/sol_elite`] : null
    const custree_id = solElite?.want_use && solElite.cTree ? solElite.cTree.id : null

    history_spots = history_spots.filter(e => e.id < history_spot?.id)
    const board = rootGetters[`${namespace}/street_board_tmp`](street)
      .filter(c => !c.includes('E'))
      .join('')

    const hp = getHistoryUrlParams({ history_spots })
    const hand = query_hand_tmp
    const rng = query_fullhand_setup.fh_rng || 'off'
    const opponent_positions = query_fullhand_setup.fh_opponent_tmp.split(',').filter(i => i)

    const data = {
      ...(custree_id
        ? { custom_tree_id: custree_id }
        : {
            gametype: gameformat.gametype,
            depth: gameformat.depth,
            stacks: gameformat.stacks,
          }),
      preflop_actions: hp.preflop_actions,
      flop_actions: hp.flop_actions,
      turn_actions: hp.turn_actions,
      river_actions: hp.river_actions,
      board,
      hand,
      rng,
      opponent_positions,
      ...(actionWithoutPracticeId ? { practice_hand_id: trainer_practice_hand_id } : {}),
    }

    const res = dispatch('api_call', {
      method: 'POST',
      mutation: 'api_practice',
      endpoint: `poker/practice/hero-situation/`,
      action: `${namespace}/gamestate_set_api_practice_silent`,
      data,
      actionArgs: { namespace, history_spot, trainer_practice_hand_id, actionWithoutPracticeId },
      mutationArgs: { namespace },
      hasCancel: false,
    })
    return res
  },
  api_practice_bot_silent({ dispatch, rootGetters }, { namespace }) {
    const trainer_practice_hand_id = rootGetters[`${namespace}/trainer_practice_hand_id`]
    const history_spot = rootGetters[`${namespace}/history_spot`]
    let history_spots = rootGetters[`${namespace}/history_spots`]
    const street = rootGetters[`${namespace}/street`]
    const gameformat = rootGetters[`${namespace}/gameformat`]

    const solElite = rootGetters ? rootGetters[`${namespace}/sol_elite`] : null
    const custree_id = solElite?.want_use && solElite.cTree ? solElite.cTree.id : null
    const cussol_id =
      solElite?.want_use && solElite.custom_solution_id ? solElite.custom_solution_id : null

    history_spots = history_spots.filter(e => e.id < history_spot?.id)
    const board = rootGetters[`${namespace}/street_board_tmp`](street)
      .filter(c => !c.includes('E'))
      .join('')
    const hp = getHistoryUrlParams({ history_spots })

    const params = {
      ...(custree_id
        ? {
            custom_tree_id: custree_id,
            custom_solution_id: cussol_id,
          }
        : {
            gametype: gameformat.gametype,
            depth: gameformat.depth,
            stacks: gameformat.stacks,
          }),

      preflop_actions: hp.preflop_actions,
      flop_actions: hp.flop_actions,
      turn_actions: hp.turn_actions,
      river_actions: hp.river_actions,
      board,
    }

    dispatch('api_call', {
      mutation: 'api_practice_bot_action',
      endpoint: `poker/available-actions/`,
      action: `${namespace}/gamestate_set_api_practice_bot_silent`,
      params,
      actionArgs: { namespace, history_spot, trainer_practice_hand_id },
      mutationArgs: { namespace },
      hasCancel: false,
    })
  },

  api_practice_showdown({ dispatch, rootGetters }, { namespace }) {
    const trainer_practice_hand_id = rootGetters[`${namespace}/trainer_practice_hand_id`]
    const history_spots = rootGetters[`${namespace}/history_spots`]
    const gameformat = rootGetters[`${namespace}/gameformat`]
    const query_hand_tmp = rootGetters[`${namespace}/query_hand_tmp`]
    const query_fullhand_setup = rootGetters[`${namespace}/query_fullhand_setup`]
    const query_board_tmp = rootGetters[`${namespace}/query_board_tmp`]

    const solElite = rootGetters ? rootGetters[`${namespace}/sol_elite`] : null
    const custree_id = solElite?.want_use && solElite.cTree ? solElite.cTree.id : null

    const hp = getHistoryUrlParams({ history_spots })

    const hero_position = query_fullhand_setup.fh_hero_tmp
    // debugger
    const params = {
      ...(custree_id
        ? { custom_tree_id: custree_id }
        : {
            gametype: gameformat.gametype,
            depth: gameformat.depth,
            stacks: gameformat.stacks,
          }),
      preflop_actions: hp.preflop_actions,
      flop_actions: hp.flop_actions,
      turn_actions: hp.turn_actions,
      river_actions: hp.river_actions,
      board: query_board_tmp,
      hand: query_hand_tmp,
      hero_position,
      practice_hand_id: trainer_practice_hand_id,
    }
    dispatch('api_call', {
      method: 'GET',
      endpoint: `poker/practice/showdown/`,
      mutation: 'api_practice_showdown',
      action: `${namespace}/gamestate_set_api_practice_showdown`,
      params,
      actionArgs: { namespace, trainer_practice_hand_id },
      mutationArgs: { namespace },
      hasCancel: false,
    })
  },
  api_practice_register_showdown({ dispatch, rootGetters }, { namespace }) {
    // stop_after_action mode only so BE knows when to end the hand
    const trainer_practice_hand_id = rootGetters[`${namespace}/trainer_practice_hand_id`]
    const history_spots = rootGetters[`${namespace}/history_spots`]
    const gameformat = rootGetters[`${namespace}/gameformat`]
    const query_hand_tmp = rootGetters[`${namespace}/query_hand_tmp`]
    const query_fullhand_setup = rootGetters[`${namespace}/query_fullhand_setup`]
    const query_board_tmp = rootGetters[`${namespace}/query_board_tmp`]

    const solElite = rootGetters ? rootGetters[`${namespace}/sol_elite`] : null
    const custree_id = solElite?.want_use && solElite.cTree ? solElite.cTree.id : null

    const hp = getHistoryUrlParams({ history_spots })

    const hero_position = query_fullhand_setup.fh_hero_tmp
    // debugger
    const params = {
      ...(custree_id
        ? { custom_tree_id: custree_id }
        : {
            gametype: gameformat.gametype,
            depth: gameformat.depth,
            stacks: gameformat.stacks,
          }),
      preflop_actions: hp.preflop_actions,
      flop_actions: hp.flop_actions,
      turn_actions: hp.turn_actions,
      river_actions: hp.river_actions,
      board: query_board_tmp,
      hand: query_hand_tmp,
      hero_position,
      practice_hand_id: trainer_practice_hand_id,
    }
    dispatch('api_call', {
      method: 'GET',
      endpoint: `poker/practice/showdown/`,
      params,
      hasCancel: false,
    })
  },

  api_practice_register_cheats({ dispatch, rootGetters }, { namespace }) {
    const trainer_practice_hand_id = rootGetters[`${namespace}/trainer_practice_hand_id`]
    dispatch('api_call', {
      method: 'PATCH',
      endpoint: `poker/practice/practice-hands/${trainer_practice_hand_id}/`,
      action: `${namespace}/trainer_set_cheats_reqistered`,
      actionArgs: { value: true },
      data: { is_competitive: false },
      hasCancel: false,
    })
  },
  api_practice_action_tracking({ commit, dispatch, rootGetters }, { namespace, action }) {
    const data = { selected: true }
    dispatch('api_call', {
      method: 'PUT',
      endpoint: `poker/practice/available-actions/${action.practice_action_id}/`,
      mutation: 'api_practice_action_tracking',
      action: `${namespace}/gamestate_set_api_practice_action_tracking`,
      mutationArgs: { namespace },
      actionArgs: { action, namespace },
      data,
      hasCancel: false,
    })
  },
  api_practice_quizz_tracking({ commit, dispatch, rootGetters }, { namespace, answer }) {
    const data = { selected: true }
    dispatch('api_call', {
      method: 'PATCH',
      endpoint: `poker/practice/quiz-variants/${answer.id}/`,
      mutationArgs: { namespace },
      data,
      hasCancel: false,
    })
  },
}

export default trainerCalls
